import './styles.css'

import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'

import { BlogApp } from './BlogApp'

const rootEl = document.getElementById('root')
if (!rootEl) throw new Error('Root element not found')

createRoot(rootEl).render(
  <BrowserRouter>
    <BlogApp />
  </BrowserRouter>,
)
